module.exports = __webpack_public_path__ + "static/media/multifamily_hero.b27100c3.jpg";